import { ButtonConfig, TeamroomView } from './TeamroomManagement.types';
import { Icons } from '../../atoms/SVG';
import { BtnModifier } from '../../molecules/Btn';

export const ACTIVATION_VIEW_KEYS = new Set([
  TeamroomView.REQUEST_ACTIVATION,
  TeamroomView.ACCEPT_ACTIVATION,
  TeamroomView.REJECT_ACTIVATION,
]);

export const BUTTON_CONFIGS: ButtonConfig[] = [
  { key: TeamroomView.INVITE, icon: Icons.ADD_USER_PLUS, variant: 'anchor', isModal: true, initialFocusIndex: 1 },
  {
    key: TeamroomView.INVITE_UNREGISTERED,
    icon: Icons.INVITE_UNKNOWN_USER,
    variant: 'anchor',
    isModal: true,
    initialFocusIndex: 2,
  },
  { key: TeamroomView.JOIN, icon: Icons.ENTER_TEAMROOM_ARROW, variant: 'anchor', isModal: false },
  { key: TeamroomView.JOIN_REQUEST, icon: Icons.ENTER_TEAMROOM_ARROW, variant: 'anchor', isModal: false },
  { key: TeamroomView.LEAVE, icon: Icons.LEAVE_TEAMROOM_ARROW, variant: 'anchor', isModal: true, initialFocusIndex: 1 },
  { key: TeamroomView.REQUEST_ACTIVATION, icon: undefined, variant: 'textButton', isModal: true, initialFocusIndex: 1 },
  {
    key: TeamroomView.ACCEPT_ACTIVATION,
    icon: Icons.ACCEPT_CHECK,
    variant: 'iconButton',
    isModal: true,
    modifier: [BtnModifier.SINGLE_ACTION_YES, BtnModifier.TRANSPARENT],
    initialFocusIndex: 1,
  },
  {
    key: TeamroomView.REJECT_ACTIVATION,
    icon: Icons.DECLINE_CROSS,
    variant: 'iconButton',
    isModal: true,
    modifier: [BtnModifier.MARGIN_LEFT, BtnModifier.SINGLE_ACTION_NO, BtnModifier.TRANSPARENT],
    initialFocusIndex: 1,
  },
];
